/* Keeps the Releasit summary aligned with the selected quantity offer.
   Before a talla is chosen the app shows subtotal $0 and still applies the
   fixed discount, which makes the total negative. */
(function () {
  'use strict';

  function parseMoney(text) {
    var raw = String(text || '');
    var neg = /-\s*\d/.test(raw);
    var digits = raw.replace(/[^\d]/g, '');
    var n = digits ? parseInt(digits, 10) : 0;
    return neg ? -n : n;
  }

  function formatMoney(n) {
    var sign = n < 0 ? '-' : '';
    var body = String(Math.abs(Math.round(n))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + sign + body;
  }

  function lineValue(form, key) {
    var line = form.querySelector('[data-checkout-line="' + key + '"]');
    if (!line) return null;
    return line.querySelector('._rsi-modal-checkout-line-value');
  }

  function selectedPrices() {
    var card = document.querySelector('._rsi-quantity-offers-selected');
    if (!card) return null;
    var now = card.querySelector('._rsi-quantity-offers-new-price');
    var old = card.querySelector('._rsi-quantity-offers-old-price');
    var plaque = card.querySelector('._rsi-quantity-offers-plaque');
    if (!now) return null;
    return {
      now: parseMoney(now.textContent),
      old: old ? parseMoney(old.textContent) : 0,
      shippingIncluded: /env[ií]o incluido/i.test((plaque && plaque.textContent) || '')
    };
  }

  function fix() {
    var form = document.querySelector('#_rsi-cod-form-modal-form');
    if (!form) return;
    var subEl = lineValue(form, 'subtotal');
    var shipEl = lineValue(form, 'shipping');
    var discEl = lineValue(form, 'discount');
    var totalEl = lineValue(form, 'total');
    if (!subEl || !totalEl) return;

    var offer = selectedPrices();
    var sub = parseMoney(subEl.textContent);
    var disc = Math.abs(parseMoney(discEl && discEl.textContent));
    var ship = Math.abs(parseMoney(shipEl && shipEl.textContent));
    var broken = sub <= 0 && offer && offer.now > 0 && disc > 0;
    var negative = parseMoney(totalEl.textContent) < 0;
    if (!broken && !negative) return;

    var merchandise = offer && offer.old > offer.now ? offer.old : (offer ? offer.now + disc : sub);
    if (merchandise < disc) merchandise = disc;
    if (offer && offer.shippingIncluded) ship = 0;
    else if (offer && offer.now >= 49999) ship = 0;
    var total = merchandise - disc + ship;
    if (total < 0) total = 0;

    if (parseMoney(subEl.textContent) !== merchandise) subEl.textContent = formatMoney(merchandise);
    if (shipEl && parseMoney(shipEl.textContent) !== ship) shipEl.textContent = formatMoney(ship);
    if (parseMoney(totalEl.textContent) !== total) totalEl.textContent = formatMoney(total);
    var label = formatMoney(total);
    document.querySelectorAll('.rsi-cod-form-submit-total-value').forEach(function (el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      try { fix(); } catch (e) {}
    }, 40);
  }

  function boot() {
    schedule();
    function attach() {
      ['_rsi-cod-form-modal', '_rsi-cod-form-embed'].forEach(function (id) {
        var modal = document.getElementById(id);
        if (!modal || modal.dataset.svOfferWatch) return;
        modal.dataset.svOfferWatch = '1';
        new MutationObserver(schedule).observe(modal, { childList: true, subtree: true, characterData: true });
      });
      schedule();
    }
    attach();
    new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
